import React from 'react';
import { Button, Form, Badge, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DetalleCuentaMovimientos = () => {
    return (
        <>
            <div className="d-flex flex-column flex-xl-row justify-content-between align-items-xl-end mt-4 mb-3 gap-3">
                <h5 className="fw-bold text-dark mb-0">
                    <FontAwesomeIcon icon="list-ul" className="me-2 text-primary" />
                    Últimos Movimientos
                </h5>
                
                <div className="d-flex flex-column flex-md-row flex-grow-1 justify-content-xl-end gap-2" style={{ maxWidth: '850px' }}>
                    <InputGroup size="sm" className="flex-grow-1">
                        <InputGroup.Text className="bg-white"><FontAwesomeIcon icon="search" className="text-muted" /></InputGroup.Text>
                        <Form.Control type="text" placeholder="Buscar concepto o referencia..." />
                    </InputGroup>
                    <Form.Select size="sm" className="flex-grow-1" style={{ minWidth: '130px', maxWidth: '200px' }}>
                        <option value="">Todo el año</option>
                        <option value="1">Enero</option>
                        <option value="2">Febrero</option>
                    </Form.Select>
                    <Form.Select size="sm" className="flex-grow-1" style={{ minWidth: '130px', maxWidth: '200px' }}>
                        <option value="">Tipo: Todos</option>
                        <option value="ingreso">Ingresos</option>
                        <option value="egreso">Egresos</option>
                    </Form.Select>
                    
                    <div className="d-flex gap-2">
                        <Button variant="outline-success" size="sm" className="flex-grow-1 text-nowrap" title="Exportar a Excel">
                            <FontAwesomeIcon icon="file-excel" className="me-1" /> Excel
                        </Button>
                        <Button variant="outline-danger" size="sm" className="flex-grow-1 text-nowrap" title="Descargar movimientos en PDF">
                            <FontAwesomeIcon icon="file-pdf" className="me-1" /> PDF
                        </Button>
                    </div>
                </div>
            </div>

            <div className="table-responsive shadow-sm rounded">
                <table className="table table-striped table-hover align-middle mb-0" style={{ fontSize: '0.9rem' }}>
                    <thead className="table-light text-secondary">
                        <tr>
                            <th>Fecha</th>
                            <th>Concepto</th>
                            <th>Referencia</th>
                            <th className="text-end">Monto</th>
                            <th className="text-center">Tipo</th>
                            <th className="text-center">Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>15/Jul/2026</td>
                            <td className="fw-medium">Pago de cliente principal</td>
                            <td className="text-muted">REF-92384</td>
                            <td className="text-end fw-bold text-success">+$25,000.00</td>
                            <td className="text-center"><Badge bg="success" text="success" className="bg-opacity-10 text-success px-2 py-1">Ingreso</Badge></td>
                            <td className="text-center"><Badge bg="success">Conciliado</Badge></td>
                            <td className="text-end"><Button variant="link" size="sm" className="p-0"><FontAwesomeIcon icon="eye" /></Button></td>
                        </tr>
                        <tr>
                            <td>12/Jul/2026</td>
                            <td className="fw-medium">Pago de nómina</td>
                            <td className="text-muted">NOM-2026-14</td>
                            <td className="text-end fw-bold text-danger">-$18,500.00</td>
                            <td className="text-center"><Badge bg="danger" text="danger" className="bg-opacity-10 text-danger px-2 py-1">Egreso</Badge></td>
                            <td className="text-center"><Badge bg="success">Conciliado</Badge></td>
                            <td className="text-end"><Button variant="link" size="sm" className="p-0"><FontAwesomeIcon icon="eye" /></Button></td>
                        </tr>
                        <tr>
                            <td>10/Jul/2026</td>
                            <td className="fw-medium">Comisión por manejo de cuenta</td>
                            <td className="text-muted">COM-9912</td>
                            <td className="text-end fw-bold text-danger">-$350.00</td>
                            <td className="text-center"><Badge bg="danger" text="danger" className="bg-opacity-10 text-danger px-2 py-1">Egreso</Badge></td>
                            <td className="text-center"><Badge bg="warning" text="dark">Pendiente</Badge></td>
                            <td className="text-end"><Button variant="outline-primary" size="sm" title="Vincular factura" className="py-0 px-2" style={{fontSize: '0.75rem'}}>Vincular</Button></td>
                        </tr>
                        <tr>
                            <td>01/Jul/2026</td>
                            <td className="fw-medium">Transferencia SPEI recibida</td>
                            <td className="text-muted">SPEI-882193</td>
                            <td className="text-end fw-bold text-success">+$12,300.00</td>
                            <td className="text-center"><Badge bg="success" text="success" className="bg-opacity-10 text-success px-2 py-1">Ingreso</Badge></td>
                            <td className="text-center"><Badge bg="warning" text="dark">Pendiente</Badge></td>
                            <td className="text-end"><Button variant="outline-primary" size="sm" title="Vincular factura" className="py-0 px-2" style={{fontSize: '0.75rem'}}>Vincular</Button></td>
                        </tr>
                        <tr>
                            <td>28/Jun/2026</td>
                            <td className="fw-medium">Pago de servicios (CFE)</td>
                            <td className="text-muted">CFE-112233</td>
                            <td className="text-end fw-bold text-danger">-$2,100.00</td>
                            <td className="text-center"><Badge bg="danger" text="danger" className="bg-opacity-10 text-danger px-2 py-1">Egreso</Badge></td>
                            <td className="text-center"><Badge bg="success">Conciliado</Badge></td>
                            <td className="text-end"><Button variant="link" size="sm" className="p-0"><FontAwesomeIcon icon="eye" /></Button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center mt-3">
                <Button variant="link" className="text-muted text-decoration-none small">Cargar más movimientos <FontAwesomeIcon icon="chevron-down" className="ms-1" /></Button>
            </div>
        </>
    );
};
